import { documentsFetch, notesFetch, kbArticlesFetch } from '../../functions/documents/index.js'

export const knowledgeBase = {
  extends: 'AppPage',
  metadata: { title: 'Knowledge base / Documents / Symbols Workspace' },

  fetch: [
    documentsFetch,
    notesFetch,
    kbArticlesFetch
  ],

  DocsSidebar: {},
  KnowledgeBaseMain: {}
}
